import * as types from './types';
import domainHelper from '../../../helpers/request/domain';

export const fetchProject = ({ commit, dispatch }) => domainHelper.getProjectId()
  .then((response) => {
    const { data } = response;
    commit(types.SET_PROJECT, data);
    commit(types.SET_TITLE, data.name);
    commit(types.SET_DESCRIPTION, data.description);
    dispatch('setImages', data.theme_medias);
  });

export const resetProjectData = ({ commit }) => commit(types.RESET_PROJECT_DATA);

export const setImages = ({ commit }, images) => {
  if (images.favicon) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'shortucut icon');
    link.setAttribute('type', 'image/x-icon');
    link.href = images.favicon.url;

    document.head.appendChild(link);
  }

  return commit(types.SET_IMAGES, images);
};



// WEBPACK FOOTER //
// ./src/screens/App/store/actions.js